import React from 'react';
import { Box, Chip } from '@mui/material';
import { SPACING } from '../../../../theme';
import PropTypes from 'prop-types';

/**
 * TemplateTags Component
 * Displays template category, status, and tags (max 3 visible)
 */
const TemplateTags = ({ template }) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      gap={0.5}
      mb={SPACING.sm}
      sx={{ minHeight: '24px' }}
    >
      <Chip
        label={template.template_category || template.category || 'General'}
        size="small"
        color="primary"
        variant="outlined"
        sx={{ fontSize: '0.6875rem', height: '20px' }}
      />
      <Chip
        label={template.version_status || template.status || 'Active'}
        size="small"
        color="success"
        sx={{ fontSize: '0.6875rem', height: '20px' }}
      />
      {template.tags?.slice(0, 1).map((tag, index) => (
        <Chip
          key={`tag-${index}`}
          label={tag}
          size="small"
          variant="outlined"
          sx={{ fontSize: '0.6875rem', height: '20px' }}
        />
      ))}
      {template.tags?.length > 1 && (
        <Chip
          label={`+${template.tags.length - 1}`}
          size="small"
          variant="outlined"
          sx={{ fontSize: '0.6875rem', height: '20px' }}
        />
      )}
    </Box>
  );
};

TemplateTags.propTypes = {
  template: PropTypes.object.isRequired,
};

export default TemplateTags;
